<template>
	<div>
		<div class="entrance" v-if="type == 1">
			<p class="entrance-item text-white text-xs pointer margin-bottom worker" @click="golink('center','release')">免费发布招工</p>
			<p class="entrance-item text-white text-xs pointer resume" @click="golink('center','resume')">管理找活名片</p>
		</div>
		<div class="entrance" v-if="type == 2">
			<p class="entrance-item text-white text-xs pointer margin-bottom worker" @click="showqun">入群快速招人</p>
			<p class="entrance-item text-white text-xs pointer resume" @click="golink('center')">管理我的招工</p>
		</div>
		<div class="entrance" v-if="type == 3">
			<p class="entrance-item text-white text-xs pointer margin-bottom worker" @click="golink('center')">免费发布租赁</p>
			<p class="entrance-item text-white text-xs pointer resume" @click="golink('center')">管理租赁信息</p>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		props:{
			type: {
			  type: [String,Number],
			  default:1
			},
		},
		name: '',
		data() {
			return {
			}
		},
		methods: {
			/**
			 * 跳转页面
			 * name   string   页面路由
			 * type   string   页面传参判断个人中心显示组件
			 * */
			golink(name,type){
				if(localStorage.getItem('user_token')){
					let query = {}
					if(type){
						query.type = type
					}
					this.$router.push({
						name:name,
						query
					})
				}else{
					Bus.$emit("showlogon")
				}
				
			},
			/**
			 * 展示入群弹窗
			 * */
			showqun(){
				Bus.$emit('showqun')
			}
		}
	}
</script>

<style lang="less" scoped>
	.entrance{
		position: fixed;
		top: 400px;
		right: 0;
		.entrance-item{
			width: 153px;
			height: 46px;
			line-height: 46px;
			border-radius: 23px 0px 0px 23px;
		}
		.worker{
			background: #09827B;
		}
		.resume{
			background: #1299E4;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/public/right.vue